import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../entities';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ForgePioHelpjuiceIcon } from './icon';
import { ForgePioHelpjuiceSearchResultIcon } from './search-result-icon';

export const forgePioHelpjuiceConfig: ThirdPartyConfig = {
	displayName: 'Helpjuice by Pio',
	id: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
	resourceType: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
	icon: get3PLogo(ForgePioHelpjuiceIcon, 'ForgePioHelpjuice', 'medium'),
	searchResultIcon: get3PLogo(ForgePioHelpjuiceSearchResultIcon, 'ForgePioHelpjuice', 'large'),
	integrationAri: 'ari:cloud:platform::integration/8durapLyclxZeEexKkwxw6ZpCRpBz4dP',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
